// Utility: get random number in range
  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  // Apply wiggle effect to text nodes only, preserving HTML structure
  function applyWiggle(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.trim()) {
        textNodes.push(node);
      }
    }
    
    textNodes.forEach(textNode => {
      const text = textNode.textContent;
      const parent = textNode.parentNode;
      const fragment = document.createDocumentFragment();
      
      // Split by words to keep them together
      const words = text.split(/(\s+)/);
      
      words.forEach(word => {
        if (/\s/.test(word)) {
          // Preserve whitespace
          fragment.appendChild(document.createTextNode(word));
        } else {
          // Wrap each word in a container
          const wordSpan = document.createElement('span');
          wordSpan.style.display = 'inline-block';
          wordSpan.style.whiteSpace = 'nowrap';
          
          // Wrap each character in the word
          for (let i = 0; i < word.length; i++) {
            const char = word[i];
            const span = document.createElement('span');
            span.className = 'char';
            span.textContent = char;
            span.style.display = 'inline-block';
            span.style.transform = `translate(${random(-6, 6)}%, ${random(-2, 2)}%)`;
            wordSpan.appendChild(span);
          }
          
          fragment.appendChild(wordSpan);
        }
      });
      
      parent.replaceChild(fragment, textNode);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const footerItems = document.querySelectorAll('.distorted-text');
    
    footerItems.forEach(item => {
      applyWiggle(item);
    });
  });